exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content.has-buttons[data-v-2b9880ee] {\n  margin-right: 92px;\n}\n.content[data-v-2b9880ee] {\n  width: 100%;\n  height: 100%;\n  overflow-x: clip;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.header-wrapper[data-v-2b9880ee] {\n  background-color: white;\n}", ""]);

// exports
